import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from '@osc-utils/services/spinner.service';
import { map } from 'rxjs/operators';
import { DYNAMIC_SELECT_ITEM } from 'src/app/app.constants';
import { CommonSnackBarService } from 'src/app/_services/common-snack-bar.service';
import { ReportTemplateDesignService } from 'src/app/_services/report-template-design.service';
import { StorageService, REPORT_TEMPLATE___APPLICATION_TYPE } from '../../_services/storage.service';
import { ReportNewPreviewComponent } from '../report-new-preview/report-new-preview.component';
import { ReportTemplateMoveConfirmDialogComponent } from 'src/app/common-dialog/report-template-move-confirm-dialog/report-template-move-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from 'src/app/_services/lang-update.service';

@Component({
    selector: 'app-report-template-new-design',
    templateUrl: './report-template-new-design.component.html',
    styleUrls: ['./report-template-new-design.component.scss'],
    standalone: false
})
export class ReportTemplateNewDesignComponent implements OnInit {

  public title: string;
  public subTitle: string;
  public timer: any;
  public isReady: boolean;
  public isVisol: boolean = false;
  @ViewChild(ReportNewPreviewComponent) public preview: ReportNewPreviewComponent;

  constructor(
    private route: ActivatedRoute,
    public designService: ReportTemplateDesignService,
    private snackBar: MatSnackBar,
    private commonSnackBar: CommonSnackBarService,
    private spinnerService: SpinnerService,
    private storageService: StorageService,
    private translate: TranslateService,
    private langService: LangUpdateService
  ) {
    this.langService.prepare(this, this.translate);

    this.spinnerService.show(this.spinnerService.mainSpinnerId);
    const templateId: string = this.route.snapshot.params.reportTemplateId;
    this.designService.reportTemplateId = templateId;

    const appType = this.storageService.fetchApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE);
    if (appType) {
      this.isVisol = appType.IsVisol;
    }
    // TODO fine tune the below code after testing
    if (DYNAMIC_SELECT_ITEM.filter(x => x.label == 'visualEvent.visualEventType').length > 0) {
      [...Array(9)].forEach(() => {
        DYNAMIC_SELECT_ITEM.pop();
      });
    }
    this.designService.initialize(templateId, this.isVisol);
    this.designService.onReady.subscribe((message: string) => {
      this.isReady = true;
      this.spinnerService.hide(this.spinnerService.mainSpinnerId);
      this.title = this.translate.instant('templatenewDesign.templatedesign');
      this.subTitle = this.designService.getTemplateName();
    });
  }

  public ngOnInit() { }
}
@Injectable()
export class BeforeunloadGuardNew {
  constructor(
    private dialog: MatDialog
  ) { }
  public canDeactivate(component: ReportTemplateNewDesignComponent) {
    if (component.preview.isChangeTemplate()) {
      const dialogRef = this.dialog.open(ReportTemplateMoveConfirmDialogComponent, {
        width: '450px',
        height: '280px',
        disableClose: true,
        data: {
          isMove: true, component,
          isError: component.preview.saveDisabled()
        }
      });
      return dialogRef.afterClosed().pipe(map(result => {
        if (result || result !== '') {
          return true;
        } else {
          return false;
        }
      }));
    } else {
      return true;
    }
  }
}
